import type { ActionReturn } from 'svelte/action';

interface Attributes {
	onvisible: (e: CustomEvent<boolean>) => void;
}

export function checkVisibility(
	node: HTMLElement,
	options: IntersectionObserverInit & { once?: boolean } = {}
): ActionReturn<IntersectionObserverInit, Attributes> {
	const { threshold = 1, root, rootMargin, once = false } = options;

	const observer = new IntersectionObserver(
		(entries) => {
			node.dispatchEvent(
				new CustomEvent('visible', { detail: entries[0]?.isIntersecting || false })
			);
			if (once) {
				observer.disconnect();
			}
		},
		{ threshold, root, rootMargin }
	);
	observer.observe(node);

	return {
		destroy() {
			observer?.disconnect();
		}
	};
}
